/* eslint-disable @typescript-eslint/no-unused-vars */import React, { FunctionComponent, ReactElement, ReactNode, useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ModalStatus } from '../../constants/constants';
import { store } from '../../store/store';
import { createRoot } from 'react-dom/client';

export interface Modal extends HTMLElement {
  show: boolean;
  noClose: boolean;
  contentSize: DOMRect;
  fit: boolean;
  name: string;
}

export interface ModalStyleItems {
  '--color-modal'?: string;
  '--background-overlay'?: string;
  '--window-margin'?: string;
  '--window-min-width'?: string;
  '--window-min-height'?: string;
  '--window-max-width'?: string;
  '--window-max-height'?: string;
  position?: string;
}

interface ModalContainerProps {
  children: React.JSX.Element | React.JSX.Element[];
  isOpen: boolean;
  withComboInput?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  onListSelected?: (event: Event) => void;
  onElementSelected?: (event: Event) => void;
}

export const ModalContainer: FunctionComponent<ModalContainerProps> = ({
  children,
  isOpen,
  withComboInput,
  onOpen,
  onClose,
  onListSelected,
  onElementSelected,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}): ReactElement | any => {
  const [modal, setModal] = useState<Modal | null>(null);
  const [isOpened, setOpened] = useState<boolean>(false);
  const { modalStatus, dispatchModalStatus } = useContext(store);
  //TODO we need this or no?
  const style: ModalStyleItems = {};
  const closeModal = () => {
    if (modal) {
      for (const key in style) {
        modal.style.setProperty(key, '');
      }
      modal.show = false;
      document.body.style.overflow = 'unset';
      dispatchModalStatus(ModalStatus.CLOSED);
    }
  };
  const openModal = () => {
    if (!isOpened) {
      const newModal: Modal = InitModal();
      setModal(newModal);
      for (const key in style) {
        newModal.style.setProperty(key, style[key as keyof ModalStyleItems] || '');
      }
      if (window.innerWidth < 1024) newModal.fit = true;
      newModal.show = true;

      const root = createRoot(newModal);
      root.render(<></>);

      //ReactDOM.render(<></>, newModal);
      document.body.style.overflow = 'hidden';
    }
  };

  const onShowChanged = (event: Event) => {
    if ((event as CustomEvent).detail.value === false) {
      setOpened(false);
      if (typeof onClose === 'function') onClose();
    } else if ((event as CustomEvent).detail.value === true) {
      setOpened(true);
      if (typeof onOpen === 'function') onOpen();
    }
  };
  // for comboItem in modal
  const onListItemSelected = (event: Event) => {
    closeModal();
    if (typeof onListSelected === 'function') onListSelected(event);
  };

  //for genderinput type in modal
  const OnSelectedElementChanged = (event: Event) => {
    closeModal();
    if (typeof onElementSelected === 'function') onElementSelected(event);
  };

  useEffect(() => {
    isOpen ? openModal() : closeModal();
  }, [isOpen]);

  useEffect(() => {
    if (isOpened) renderChildren();
  }, [isOpened]);

  useEffect(() => {
    if (modal) {
      modal.addEventListener('show-changed', onShowChanged);
      modal.addEventListener('selected-list', onListItemSelected);
      modal.addEventListener('selected-element-changed', OnSelectedElementChanged);
    }
    return () => {
      if (modal) {
        modal.removeEventListener('show-changed', onShowChanged);
        modal.removeEventListener('selected-list', onListItemSelected);
        modal.removeEventListener('selected-element-changed', OnSelectedElementChanged);
      }
    };
  }, [modal]);

  const InitModal: () => Modal = () => {
    const modalDs: Modal = document.body.querySelector('base-modal') as Modal;
    modalDs.show = false;
    modalDs.noClose = false;
    modalDs.fit = false;
    return modalDs;
  };

  const renderChildren = () => {
    if (modal) {
      if (withComboInput) {
        const { height: heightModal, bottom: bottomModal, top: topModal } = modal.contentSize;
        const listHeight = `${heightModal + topModal - (bottomModal - heightModal) - 200}px`;
        const childrenWithProps = React.Children.map<ReactNode, ReactNode>(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, { ...{ comboListHeight: listHeight } });
          }
          return child;
        });
        const root = createRoot(modal);
        if (childrenWithProps) {
          root.render(childrenWithProps as unknown as React.JSX.Element);
          // ReactDOM.render(childrenWithProps as unknown as React.JSX.Element, modal);
        } else {
          root.render(children);
        }
        dispatchModalStatus(ModalStatus.OPEN);
      }
    }
    return <></>;
  };
};
